import ContratoService from '@/services/ContratoService'

export const actions = {
    async gerarContratoInstalacaoPiscina ({commit, dispatch}, vendaId) {
        commit('setOverlay', true)
        await ContratoService.gerarContratoInstalacaoPiscina(vendaId)
        .then(res => {
            commit('setContrato', res.data)
            commit('snackbarSuccess', 'Contrato gerado.')
            commit('setOverlay', false)
        })
        .catch(e => {
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao gerar contrato.')
            console.log(e)
        })
    },
    setModalVisualizarContrato: ({ commit }, status) => {
        commit('setModalVisualizarContrato', false)
        setTimeout(() => {
            commit('setModalVisualizarContrato', status)
        }, 100)
    },
}

export default {}